export default __webpack_public_path__ + "redo.asset.fb68544f93dd1e6c2ce066e198f647ba.svg";